module.exports = __webpack_public_path__ + "static/media/logo.34c1f270.png";